import { Action } from '@ngrx/store';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { CustomersTO, UserContextTO } from 'app/core/store/session/user-context/user-context.interface';

export const USERCONTEXT_LOAD = 'usercontext:USERCONTEXT_LOAD';
export const USERCONTEXT_LOAD_FAIL = 'usercontext:USERCONTEXT_LOAD_FAIL';
export const USERCONTEXT_LOAD_SUCCESS = 'usercontext:USERCONTEXT_LOAD_SUCCESS';
export const CUSTOMERS_CLEAR = 'usercontext:CUSTOMERS_CLEAR';
export const CUSTOMERS_LOAD = 'usercontext:CUSTOMERS_LOAD';
export const CUSTOMERS_LOAD_FAIL = 'usercontext:CUSTOMERS_LOAD_FAIL';
export const CUSTOMERS_LOAD_SUCCESS = 'usercontext:CUSTOMERS_LOAD_SUCCESS';
export const CUSTOMER_GET_SHIPTOS_CLEAR = 'usercontext:CUSTOMER_GET_SHIPTOS_CLEAR';
export const CUSTOMER_GET_SHIPTOS_LOAD = 'usercontext:CUSTOMER_GET_SHIPTOS_LOAD';
export const CUSTOMER_GET_SHIPTOS_LOAD_FAIL = 'usercontext:CUSTOMER_GET_SHIPTOS_LOAD_FAIL';
export const CUSTOMER_GET_SHIPTOS_LOAD_SUCCESS = 'usercontext:CUSTOMER_GET_SHIPTOS_LOAD_SUCCESS';

export class UserContextLoadAction implements Action {
  readonly type = USERCONTEXT_LOAD;
}

export class UserContextLoadSuccessAction implements Action {
  readonly type = USERCONTEXT_LOAD_SUCCESS;
  logPayload = true;

  constructor(readonly payload: UserContextTO) { }
}

export class UserContextLoadFailAction implements Action {
  readonly type = USERCONTEXT_LOAD_FAIL;
  logPayload = true;

  constructor(readonly payload: any) { }
}

export class CustomersClearAction implements Action {
  readonly type = CUSTOMERS_CLEAR;
}

export class CustomersLoadAction implements Action {
  readonly type = CUSTOMERS_LOAD;
  logPayload = true;

  constructor(readonly payload: string) { } // salesOrganisationId
}

export class CustomersLoadSuccessAction implements Action {
  readonly type = CUSTOMERS_LOAD_SUCCESS;

  constructor(readonly payload: CustomersTO) { }
}

export class CustomersLoadFailAction implements Action {
  readonly type = CUSTOMERS_LOAD_FAIL;
  logPayload = true;

  constructor(readonly payload: any) { }
}

export class CustomerGetShipTosClearAction implements Action {
  readonly type = CUSTOMER_GET_SHIPTOS_CLEAR;
}

export class CustomerGetShipTosLoadAction implements Action {
  readonly type = CUSTOMER_GET_SHIPTOS_LOAD;
  logPayload = true;

  constructor(readonly payload: { customerId: string }) { }
}

export class CustomerGetShipTosLoadSuccessAction implements Action {
  readonly type = CUSTOMER_GET_SHIPTOS_LOAD_SUCCESS;

  constructor(readonly payload: { customerId: string; shipTos: Definition[] }) { }
}

export class CustomerGetShipTosLoadFailAction implements Action {
  readonly type = CUSTOMER_GET_SHIPTOS_LOAD_FAIL;
  logPayload = true;

  constructor(readonly payload: any) { }
}

export type Actions =
  | UserContextLoadAction
  | UserContextLoadSuccessAction
  | UserContextLoadFailAction
  | CustomersClearAction
  | CustomersLoadAction
  | CustomersLoadSuccessAction
  | CustomersLoadFailAction
  | CustomerGetShipTosClearAction
  | CustomerGetShipTosLoadAction
  | CustomerGetShipTosLoadSuccessAction
  | CustomerGetShipTosLoadFailAction;
